import React, { useState } from "react";
import "./AddShiftSchedule.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import AddShiftScheduleLayout from "../../layouts/Admin/AddShiftScheduleLayout";

const AddShiftSchedule = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <AddShiftScheduleLayout />
    </>
  );
};

export default AddShiftSchedule;
